import classNames from "classnames";
import Tab from "components/core/Tabs/Tab";
import Tabs from "components/core/Tabs/Tabs";
import React, { ReactElement } from "react";
import styles from "./ChartWrapper.module.scss";
import { TimeSelection } from "./data";

interface Props {
  currentPrice: number;
  startingPrice: number;
  children: React.ReactNode;
  timeSelection: TimeSelection;
  setTimeSelection(timeSelection: TimeSelection);

  inline?: boolean;
  hideDayAndWeekData?: boolean;
}

export default function ChartWrapper(props: Props): ReactElement {
  const onChange = (a: string) => {
    props.setTimeSelection(a.toLowerCase() as TimeSelection);
  };

  return (
    <div>
      <div
        className={classNames(
          styles.graphContentWrapper,
          props.inline ? styles.inline : ""
        )}
      >
        {props.children}
      </div>

      {!props.inline && (
        <Tabs
          // defaultActiveKey={props.timeSelection}
          onChange={onChange}
          heading=""
        >
          <Tab label="1D" key="1d" disabled={props.hideDayAndWeekData}>
            <></>
          </Tab>
          <Tab label="1W" key="1w" disabled={props.hideDayAndWeekData}>
            <></>
          </Tab>
          <Tab label="1M" key="1m">
            <></>
          </Tab>
          <Tab label="3M" key="3m">
            <></>
          </Tab>
          <Tab label="1Y" key="1y">
            <></>
          </Tab>
          <Tab label="5Y" key="5y">
            <></>
          </Tab>
        </Tabs>
      )}
    </div>
  );
}
